import { useCallback } from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';
import { agentTypeLabelKey } from '../utils/agentDisplayName';

export function useAgentDisplayName(): (agentType: string) => string {
  const { t } = useTranslation();
  return useCallback((agentType: string) => t(agentTypeLabelKey(agentType)), [t]);
}
